import { VoicemailOutlined } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { channelIcons } from 'domains/campaigns/pages/CurationsPage/utils';
import { CampaignChannels } from 'domains/campaigns/types';
import PageHeader from 'domains/core/components/PageHeader';
import ContentTaggingButtonWithDialog from 'domains/content/components/ContentTaggingButtonWithDialog/ContentTaggingButtonWithDialog';
import { ApplicationAccessType, CommunicationType, ContentTypeForComparison } from 'domains/content/types';
import { VoiceContentStateTypes } from '../types';
import SaveAndExitButton from '../SaveAndExitButton';
import { ContentStatus } from 'pages/ContentPage/ContentTable/ContentStatusText';

type Props = {
    applicationsAccess: ApplicationAccessType[];
    communicationType: CommunicationType;
    dispatchVoiceContentAction: React.Dispatch<any>;
    handleSave: (status?: ContentStatus) => void;
    isSaving: boolean;
    isVoicemailActive: boolean;
    setIsVoicemailActive: (isActive: boolean) => void;
    voiceContentState: VoiceContentStateTypes;
};

const VoiceBuilderPageHeader = ({
    applicationsAccess,
    communicationType,
    dispatchVoiceContentAction,
    handleSave,
    isSaving,
    isVoicemailActive,
    setIsVoicemailActive,
    voiceContentState,
}: Props) => {
    const ChannelIcon = channelIcons[CampaignChannels.VOICE_CALL];
    const voiceContentButton = (
        <Tooltip title="Edit voice content" placement="top">
            <span>
                <IconButton
                    aria-label="Edit voice content"
                    size="large"
                    onClick={() => setIsVoicemailActive(false)}
                    disabled={isSaving}
                >
                    <ChannelIcon />
                </IconButton>
            </span>
        </Tooltip>
    );

    const voicemailFallbackButton = (
        <Tooltip title="Edit voicemail & fallback" placement="top">
            <span>
                <IconButton
                    aria-label="Edit voicemail & fallback"
                    size="large"
                    onClick={() => setIsVoicemailActive(true)}
                    disabled={isSaving}
                >
                    <VoicemailOutlined />
                </IconButton>
            </span>
        </Tooltip>
    );

    return (
        <PageHeader
            icon={isVoicemailActive ? <VoicemailOutlined fontSize="inherit" /> : <ChannelIcon fontSize="inherit" />}
            header={isVoicemailActive ? 'voicemail & fallback' : 'voice'}
            headerOthers={
                <Stack
                    direction="row"
                    alignItems="center"
                    columnGap={1}
                    ml={1}
                    justifyContent="space-between"
                    width="100%"
                >
                    <Stack direction="row" columnGap={1} justifyContent="flex-start">
                        {isVoicemailActive ? voiceContentButton : voicemailFallbackButton}
                        <ContentTaggingButtonWithDialog
                            channel={ContentTypeForComparison.VOICE}
                            dispatchVoiceContentAction={dispatchVoiceContentAction}
                            selectedApplicationsAccess={applicationsAccess}
                            selectedCommunicationType={communicationType}
                        />
                    </Stack>

                    <SaveAndExitButton
                        handleSave={handleSave}
                        isLoading={isSaving}
                        voiceContentState={voiceContentState}
                    />
                </Stack>
            }
        />
    );
};

export default VoiceBuilderPageHeader;
